import * as React from "react";
import { observer } from "mobx-react";
import { UitkCard, UitkCardLink, UitkCardContentSection } from "uitk-react-cards";
import { CampaignRecommendationsWithOffersQuery } from "../../../../../../__generated__/api";
import Offers = CampaignRecommendationsWithOffersQuery.Offers;
import { Action } from "components/utility/analytics/FlexAnalyticsUtils";
import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { useLocalization } from "@shared-ui/localization-context";

export interface FlightInventoryCardProps {
  offer: Offers;
  cardIndex: number;
  campaignId: string;
  moduleName: string;
  border?: boolean;
}

export const FlightInventoryCard = observer(
  ({ offer, cardIndex, campaignId, moduleName, border }: FlightInventoryCardProps) => {
    if (offer.__typename !== "FlightOfferItem") {
      return null;
    }

    const { formatText } = useLocalization();

    return (
      <UitkCard className="FlightInventoryCard uitk-flex-justify-content-flex-start uitk-flex-column" border={border}>
        <div className="uitk-card-content uitk-cell">
          <UitkCardContentSection>
            <div className="uitk-type-200">
              <img
                className="airlinesIcon all-r-margin-one"
                src={offer.airlineImage?.url}
                alt={offer.airlineImage?.description}
              />
              <span>{offer.airlineName}</span>
            </div>
            <div
              className="uitk-type-400 truncate flightOfferName all-b-padding-one all-r-padding-one"
              dangerouslySetInnerHTML={{
                __html: formatText(
                  "merchCampaign.flightOffer.name",
                  offer.originCity,
                  offer.originAirportCode,
                  offer.destinationCity,
                  offer.destinationAirportCode
                ),
              }}
            />
            <div className="uitk-type-300">{offer.description}</div>
          </UitkCardContentSection>
          <UitkCardContentSection border="top">
            <UitkLayoutFlex justifyContent="space-between">
              <>
                <div className="uitk-type-200">{offer.dates}</div>
                {offer.flightOffer?.price.value && (
                  <div className="uitk-type-right">
                    <span className="uitk-type-100 all-r-padding-one price-prefix">
                      {offer.flightOffer.price.prefixText}
                    </span>
                    <span className="uitk-type-heading-600">{offer.flightOffer.price.value}</span>
                    <div className="uitk-type-100">{offer.flightOffer.price.qualifierText}</div>
                  </div>
                )}
              </>
            </UitkLayoutFlex>
          </UitkCardContentSection>
          <UitkCardLink>
            <TrackedLink
              moduleName={moduleName}
              action={Action.CLICK}
              href={offer.flightOffer?.actionLink.href}
              rfrr={`card-${campaignId}-${cardIndex}`}
            >
              {offer.flightOffer?.actionLink.text}
            </TrackedLink>
          </UitkCardLink>
        </div>
      </UitkCard>
    );
  }
);
